import React, { useEffect, useState, useContext } from 'react';
import TablaGenerica from '../../commons/tablaGenerica/tablaGenerica';
import {cabecerasTabla, objetoDatos, keysTablaGenerica, texts} from './SelloElectonicoSistemasFirmaData';
import {customStyle} from './SelloElectronicoSistemasFirmaStyle';
import {Grid} from '@material-ui/core';
import {properties as appProperties} from 'AppData';
import AppContext from 'AppContext';

export default function SelloElectronicoSistemasFirma() {  

    const [isPhoneVersion, setIsPhoneVersion] = useState(false);

    const context = useContext(AppContext);

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
     const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
     const obtenerTituloPagina = () =>{
        context.updateTitlePage(texts.PAGE_TITLE);
    }

    useEffect(() => {
        updateFormat();
        obtenerTituloPagina();
    }, []);

    window.addEventListener('resize', updateFormat);

    return(
        <main>
            <Grid container className={customStyle().gridPageTitle}>
                <h2 className={customStyle().classTitleH2} id={texts.ID_PAGE_TITLE}>{texts.PAGE_TITLE}</h2>
            </Grid>
            <Grid className={customStyle().backgroundRectangle}>
                <TablaGenerica headingColumns={cabecerasTabla} tableData={objetoDatos} isPhoneVersion={false} {...keysTablaGenerica}/>
            </Grid>
        </main>    
    );
}
